/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import React, { type JSX } from 'react'

export type ButtonLinkProps = JSX.IntrinsicElements['a'] & {
  variant?: 'filled' | 'outlined'
  mainColor?: string
  borderWidth?: string
  disabled?: boolean
}

export const ButtonLink = ({
  children,
  variant = 'filled',
  mainColor = '#eb2d23',
  borderWidth = '2px',
  disabled,
  ...props
}: ButtonLinkProps) => {
  let backgroundColor = mainColor
  let color = 'white'
  let border = ''
  let boxShadow = '0px 3px 8px rgba(0, 0, 0, 0.08)'
  if (variant === 'outlined') {
    backgroundColor = ''
    color = mainColor
    border = `${borderWidth} solid ${mainColor}`
    boxShadow = ''
  }

  if (disabled) boxShadow = ''

  const buttonLinkStyle = css`
    background: ${backgroundColor};
    border: ${border};
    color: ${color};
    box-shadow: ${boxShadow};
    border-radius: 30px;
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    line-height: 130%;
    pointer-events: ${disabled ? 'none' : ''};
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
  `

  return (
    <a {...props} css={buttonLinkStyle}>
      {children}
    </a>
  )
}
